import { useQuery } from '@tanstack/react-query';
import React, { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import UpdateForm from '../../components/UpdateForm';
import { AuthContext } from '../../context/AuthProvider/AuthProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faCircleCheck, faPen, faTrashCan, faCircleXmark
} from '@fortawesome/free-solid-svg-icons'

const MyTasks = () => {
    const [updateData, setUpdateData] = useState('')
    const { user } = useContext(AuthContext);
    const url = `${process.env.REACT_APP_API_URL}/my-tasks?email=${user?.email}`;
    const { data: tasks = [], isLoading, refetch } = useQuery({
        queryKey: ['my-tasks', user?.email],
        queryFn: async () => {
            const res = await fetch(url);
            const data = await res.json();
            return data.tasks;
        }
    })
    console.log(tasks);
    //handle mark the task as complete
    const handleCompleteTask = id => {
        console.log('mark as completed');
        fetch(`${process.env.REACT_APP_API_URL}/my-task/${id}`, {
            method: 'PATCH',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({ status: true })
        })
            .then(res => res.json())
            .then(data => {
                // console.log(data);
                if (data.status) {
                    refetch();
                    toast.success(data.message);
                }

            })
    }
    //handle mark the task as complete
    const handleAvailableTask = id => {
        console.log('mark as uncompleted');
        fetch(`${process.env.REACT_APP_API_URL}/my-task/${id}`, {
            method: 'PATCH',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({ status: false })
        })
            .then(res => res.json())
            .then(data => {
                // console.log(data);
                if (data.status) {
                    refetch();
                    toast.success(data.message);
                }

            })
    }

    // remove the task
    const handleTaskDelete = id => {
        fetch(`${process.env.REACT_APP_API_URL}/my-task/${id}`, {
            method: "DELETE"
        })
            .then(res => res.json())
            .then(data => {
                // console.log(data);
                if (data.status) {
                    refetch();
                    toast.success(data.message);
                }
            })
    }

    // Cancel update
    const cancelUpdate = () => {
        setUpdateData('')
    }
    return (
        <div className="max-w-5xl mx-auto py-16">
            <h2 className='text-center text-3xl font-bold mb-5'>My All Tasks</h2>
            {updateData && updateData ? (
                <UpdateForm
                    updateData={updateData}
                    cancelUpdate={cancelUpdate}
                    refetch={refetch}
                    isLoading={isLoading}
                />
            ) : null}
            <div className='mt-3'>
                {tasks && tasks.length ? <>
                    {
                        tasks?.map((task, index) =>
                            <div key={task._id} className="flex justify-between items-center bg-slate-200 p-5 rounded-md mb-3">
                                <div className={task.isTaskCompleted ? 'flex opacity-30 line-through items-center gap-5' : 'flex items-center gap-5'}>
                                    <span className="text-xl border-2 border-gray-600 p-2 rounded-full line-count">{index + 1}</span>
                                    <div className='flex gap-4'>
                                        <img src={task.taskImg} alt="Task Img" className='w-10' />
                                        <div><h3 className="text-2xl font-bold">{task.taskName}</h3>
                                            <p>{task.taskDescription}</p></div>
                                    </div>
                                </div>
                                <div className="flex gap-4 text-2xl text-green-800 ">
                                    {
                                        task.isTaskCompleted ?
                                            <span className='text-red-800 hover:text-yellow-400' title="Mark as not completed"
                                                onClick={() => handleAvailableTask(task._id)}>
                                                <FontAwesomeIcon icon={faCircleXmark} />
                                            </span> :
                                            <span className='hover:text-yellow-400' title="Mark as Completed"
                                                onClick={() => handleCompleteTask(task._id)}><FontAwesomeIcon icon={faCircleCheck} /></span>
                                    }




                                    {task.isTaskCompleted ? null : (
                                        <span className='hover:text-yellow-400' title="Edit"
                                            onClick={() => setUpdateData(task)}
                                        >
                                            <FontAwesomeIcon icon={faPen} />
                                        </span>
                                    )}

                                    <span className='hover:text-yellow-400' title="Delete"
                                        onClick={() => handleTaskDelete(task._id)}
                                    >
                                        <FontAwesomeIcon icon={faTrashCan} />
                                    </span>
                                </div>
                            </div>
                        )
                    }
                </> : <p className='text-center'>You didn't create any tasks yet...</p>}
            </div>

        </div>
    );
};

export default MyTasks;